<template>
    <th @click="$parent.sortCol(colKey)"
        :colKey="colKey"
        :class="[classes]">
        <template v-if="isCheckbox">
            <input type="checkbox" @change="handleCheckboxChange">
        </template>
        <template v-else>
            {{ text }}
        </template>
        <template v-if="sortingKey === colKey">
            <i v-if="sortingDirection === 'desc'" class="fa fa-sort-amount-desc"></i>
            <i v-else class="fa fa-sort-amount-asc"></i>
        </template>
    </th>
</template>

<script>
export default {
    props: {
        colKey: {
            type: String,
            required: true,
        },
        classes: {
            type: Array,
            required: false,
            default: function(){
                return [];
            },
        },
        text: {
            type: String,
            required: true,
        },
        sortingKey: {
            type: String,
            required: false,
            default: 'id'
        },
        sortingDirection: {
            type: String,
            required: false,
            default: 'asc',
        },
        isCheckbox: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        handleCheckboxChange(event) {
            this.$emit('checkbox-change', event.target.checked);
        }
    }
}
</script>
